import { Flex, Text } from "@chakra-ui/react";

export default function CardPIXBoleto(props: any) {
  return (
    <Flex
      w={"10vw"}
      h={"12vh"}
      //   bgColor={"red"}
      mx={4}
      borderRadius={"20px"}
      flexDir="column"
    >
      <Flex
        w={"100%"}
        h={"40%"}
        bgColor={"#1C3E92"}
        borderRadius={"20px 20px 0px 0px"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Text
          fontFamily={"Montserrat"}
          fontWeight={"700"}
          fontSize={"1rem"}
          color={"#FFFFFF"}
        >
          {props.text ? props.text.toUpperCase() : ""}
        </Text>
      </Flex>
      <Flex
        w={"100%"}
        h={"60%"}
        justifyContent={"center"}
        alignItems={"center"}
        bgColor={"white"}
        borderRadius={"0px 0px 20px 20px"}
        fontSize={"1rem"}
      >
        {props.value}
      </Flex>
    </Flex>
  );
}
